import { api } from './client'

/**
 * F-093 (TASK-0347, REQ-236-001 / REQ-237-001): client di `DataQualityController` (`/api/data-quality`,
 * solo Admin). L'anteprima legge e non scrive mai; la bonifica parte solo con `confirm: true` e gira
 * nella coda dei job (si segue con `jobsApi.mine`).
 */
export type DataQualityEntity = 'contacts' | 'people' | 'companies' | 'leads'

export const DATA_QUALITY_ENTITY_LABELS: Record<DataQualityEntity, string> = {
  contacts: 'Contatti',
  people: 'Persone',
  companies: 'Aziende',
  leads: 'Lead',
}

export const DATA_QUALITY_FIELD_LABELS: Record<string, string> = {
  Email: 'Email',
  Pec: 'PEC',
  Phone: 'Telefono',
  Mobile: 'Cellulare',
  FiscalCode: 'Codice fiscale',
  VatNumber: 'Partita IVA',
  Province: 'Provincia',
  PostalCode: 'CAP',
  City: 'Comune',
  Address: 'Indirizzo',
  Name: 'Ragione sociale',
  CompanyName: 'Ragione sociale',
}

export interface NormalizationExample {
  id: number
  field: string
  before: string | null
  after: string | null
}

export interface NormalizationFieldPreview {
  field: string
  changes: number
  examples: NormalizationExample[]
}

export interface NormalizationPreview {
  entity: DataQualityEntity
  scanned: number
  changedRows: number
  fields: NormalizationFieldPreview[]
}

export const dataQualityApi = {
  /** Sola lettura: per campo, quante righe cambierebbero e 20 esempi. */
  preview: (entity: DataQualityEntity) =>
    api<NormalizationPreview>(`/api/data-quality/normalization-preview?entity=${entity}`),

  /** 202 con l'id del job; 400 senza `confirm: true`. La stessa richiesta ripetuta non accoda due volte. */
  apply: (entity: DataQualityEntity, fields: string[]) =>
    api<{ jobId: number }>('/api/data-quality/normalization-apply', {
      method: 'POST',
      body: JSON.stringify({ entity, fields, confirm: true }),
    }),
}
